module.exports = __webpack_public_path__ + "media/images/design/icon_04-26753190a6f00db549994693709ced3b.svg";